import { render, staticRenderFns } from "./goods-show-label.vue?vue&type=template&id=4b2d2bf8&scoped=true"
import script from "./goods-show-label.vue?vue&type=script&lang=js"
export * from "./goods-show-label.vue?vue&type=script&lang=js"
import style0 from "./goods-show-label.vue?vue&type=style&index=0&id=4b2d2bf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d2bf8",
  null
  
)

export default component.exports